import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface NationalCodeResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function updateNationalCodeAction(
  uuid: string,
  nationalCode: string
): Promise<ApiResponse<NationalCodeResponse>> {
  return api.put<ApiResponse<NationalCodeResponse>>(`/users/${uuid}/update-national-code`, { nationalCode })
}

export function verifyNationalCodeAction(uuid: string): Promise<ApiResponse<NationalCodeResponse>> {
  return api.put<ApiResponse<NationalCodeResponse>>(`/users/${uuid}/verify-national-code`)
}

export function rejectNationalCodeAction(uuid: string): Promise<ApiResponse<NationalCodeResponse>> {
  return api.put<ApiResponse<NationalCodeResponse>>(`/users/${uuid}/reject-national-code`)
}
